<template>
    <div style="text-align: center">
        <el-transfer
            style="text-align: left; display: inline-block"
            v-model="value"
            filterable
            :left-default-checked="[2, 3]"
            :right-default-checked="[1]"
            :render-content="renderFunc"
            :titles="['Source', 'Target']"
            :button-texts="['到左边', '到右边']"
            :format="{
                noChecked: '${total}',
                hasChecked: '${checked}/${total}'
            }"
            @change="handleChange"
            :data="data"
        >
            <el-button class="transfer-footer" slot="left-footer" size="small">操作</el-button>
            <el-button class="transfer-footer" slot="right-footer" size="small">操作</el-button>
        </el-transfer>
    </div>
</template>
<script>
import { ref, toRefs, reactive } from "vue";
import { useRouter } from "vue-router";
export default {
    name: "zuzhi",
    setup(props, context) {
        const router = useRouter();
        const data = reactive({
            dialogVisible: true
        });

        //选中车辆  子传父
        const handleEdit = (row, column, cell, event) => {
            data.display = false;
            context.emit("clickFu", row);
        };

        return {
            handleEdit,
            ...toRefs(data),


        };
    },
};
</script>
<style lang="scss" scoped>
.zuzhi {
    width: 600px;
    height: 500px;
    position: absolute;
    background-color: rgb(40, 230, 23);
    right: 50%;
    top: 8%;
    z-index: 999;
}
</style>